import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import GameApp from '@/GameApp.vue';
import { installRouterTiming } from '@/telemetry/routerTiming';
import './types';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: GameApp,
  },
  {
    path: '/contact',
    component: GameApp,
    meta: { openContact: true },
  },
  {
    path: '/signup',
    component: GameApp,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

installRouterTiming(router);
